import BsStatistic from './index.vue'
export default BsStatistic